import { FC } from 'react'

import { useWallet } from '@aptos-labs/wallet-adapter-react'
import { useDisclosure } from '@mantine/hooks'
import Jazzicon, { jsNumberForAddress } from 'react-jazzicon'

import { DisconnectWalletModal } from 'components/DisconnectWalletModal'
import { shortAddress } from 'utils/shortAddress'

import s from './s.module.scss'

type Props = {
  disconnectButtonClassName?: string
}

const ButtonInfoAccount: FC<Props> = ({ disconnectButtonClassName }) => {
  const [opened, { close, open }] = useDisclosure(false)
  const { account, wallet } = useWallet()

  return (
    <>
      <button className={s.buttonShowInfo} onClick={open}>
        <div className={s.walletName}>
          <img alt="wallet" className={s.walletIcon} src={wallet.icon} />
          <span>{wallet.name}</span>
        </div>
        <div className={s.addressBlock}>
          <span>{shortAddress(account.address)}</span>
          <Jazzicon diameter={20} seed={jsNumberForAddress(account.address)} />
        </div>
      </button>
      <DisconnectWalletModal
        centered
        disconnectButtonClassName={disconnectButtonClassName}
        onClose={close}
        opened={opened}
        title="Connect wallet"
      />
    </>
  )
}

export default ButtonInfoAccount
